// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var HhsRace;
(function (HhsRace) {
    HhsRace[HhsRace["White"] = 1] = "White";
    HhsRace[HhsRace["Black"] = 2] = "Black";
    HhsRace[HhsRace["Asian"] = 3] = "Asian";
    HhsRace[HhsRace["NativeAmerican"] = 4] = "NativeAmerican";
    HhsRace[HhsRace["PacificIslander"] = 5] = "PacificIslander";
    HhsRace[HhsRace["Multiple"] = 6] = "Multiple";
    HhsRace[HhsRace["NoAnswer"] = 9] = "NoAnswer";
})(HhsRace || (HhsRace = {}));
//# sourceMappingURL=hhsRace.js.map